import { defineComponent as _defineComponent } from 'vue'
import {
  ButtonPrimary,
  ButtonSecondary,
  ButtonContainer,
  Modal
} from '@warrenbrasil/nebraska-web';
import { useRouter } from 'vue-router/composables';
import { Portal } from '@/modules/common/components/Portal';
import { IDynamicContent } from '@/modules/common/types';
import DynamicContent from '../DynamicContent/DynamicContent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicContentModal',
  props: {
    modalInfo: null,
    isOpen: { type: Boolean },
    title: null,
    costsButton: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const router = useRouter();

function goToCosts() {
  const url = router.resolve({ name: 'costs' }).href;
  window.open(url, '_blank');
}





return { __sfc: true,router, goToCosts, emit, ButtonPrimary, ButtonSecondary, ButtonContainer, Modal, Portal, DynamicContent }
}

})